import React, { createContext, FC, useContext } from 'react';
import { Tracker } from './model';
import { GTMEventTrackerService } from './google-tag-manager';

const tracker = new GTMEventTrackerService();
const EventTrackerContext = createContext<Tracker>(tracker);

export const useAnalyticsTracker = (): Tracker => useContext(EventTrackerContext);

export const Index: FC = ({ children }) => {
  return <EventTrackerContext.Provider value={tracker}>{children}</EventTrackerContext.Provider>;
};
